import React from "react";
import { Star } from "lucide-react";

/**
 * Read-only: <StarRating value={4.5} count={12} />
 * Interactive (half-star clicks): <StarRating value={rating} onChange={setRating} />
 */
export default function StarRating({ value = 0, onChange, size = "w-4 h-4", showValue = true, count }) {
  const interactive = typeof onChange === "function";
  const stars = [1, 2, 3, 4, 5];

  return (
    <div className="flex items-center gap-1.5">
      <div className="flex">
        {stars.map(i => {
          const filled = value >= i;
          const half = !filled && value >= i - 0.5;
          return (
            <div key={i} className={`relative ${size} ${interactive ? "cursor-pointer" : ""}`}>
              <Star className={`${size} absolute inset-0 text-slate-300`} />
              {(filled || half) && (
                <div className="absolute inset-0 overflow-hidden" style={{ width: half ? "50%" : "100%" }}>
                  <Star className={`${size} text-amber-500 fill-amber-500`} />
                </div>
              )}
              {interactive && (
                <>
                  <button
                    type="button"
                    className="absolute inset-y-0 left-0 w-1/2"
                    onClick={() => onChange(i - 0.5)}
                    aria-label={`${i - 0.5} stars`}
                  />
                  <button
                    type="button"
                    className="absolute inset-y-0 right-0 w-1/2"
                    onClick={() => onChange(i)}
                    aria-label={`${i} stars`}
                  />
                </>
              )}
            </div>
          );
        })}
      </div>
      {showValue && value > 0 && <span className="text-xs font-medium text-slate-600">{value.toFixed(1)}</span>}
      {typeof count === "number" && <span className="text-xs text-slate-400">({count})</span>}
    </div>
  );
}
